import { Box, Dialog, useMediaQuery, useTheme } from "@mui/material";
import { useHistory } from "react-router-dom";

import { useNotification } from "app/NotificationProvider";
import { mixpanel } from "common/analytics/mixpanel";
import { useTranslation } from "common/locales";
import { StyledInputContainer } from "features/StyledInputContainer";
import {
  createFileEntry,
  FileUpload,
  uploadFile,
  useAppDispatch,
  useAppSelector,
} from "model";
import AddNewFileDialog from "./AddNewFileDialog";
import { convertFromFormInput, FileEntryFormData } from "./FileEntryFormData";

export default function AddNewFile() {
  const dispatch = useAppDispatch();
  const user = useAppSelector((state) => state.user.details);
  const { notify } = useNotification();
  const history = useHistory();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const handleClose = () => {
    history.goBack();
  };
  const { t } = useTranslation();

  async function handleSave(fileEntryFormData: FileEntryFormData) {
    if (
      (!fileEntryFormData.file || !fileEntryFormData.fileName) &&
      !fileEntryFormData.fileUploadId
    ) {
      return;
    }

    if (!fileEntryFormData.fileUploadId) {
      if (!fileEntryFormData.file) {
        console.log("File content is missing, something went wrong");
        return;
      }
      const fileUpload = await dispatch(
        uploadFile({
          fileName: fileEntryFormData.fileName ?? "",
          file: fileEntryFormData.file,
        })
      );
      fileEntryFormData.fileUploadId = (fileUpload.payload as FileUpload).guid;
    }

    const fileEntry = convertFromFormInput(fileEntryFormData, user?.guid ?? "");

    await dispatch(createFileEntry(fileEntry));

    notify(t("fileEntry.add.success"));
    mixpanel.track("FileEntry created");

    handleClose();
  }
  if (!isMobile) {
    return (
      <Box
        sx={{
          width: "100%",
          maxWidth: isMobile ? "100%" : "calc(100vw - 400px)", // Limit width on desktop
          height: "100vh",
          display: "flex",
          flexDirection: "column",
          backgroundColor: "white",
          ml: isMobile ? 0 : "400px", // Push right by drawer width on desktop
          overflow: "auto",
        }}
      >
        <NewFileContainer handleSave={handleSave} handleClose={handleClose} />
      </Box>
    );
  } else {
    return (
      <Dialog fullScreen disableEscapeKeyDown open onClose={handleClose}>
        <NewFileContainer handleSave={handleSave} handleClose={handleClose} />
      </Dialog>
    );
  }
}

const NewFileContainer = ({
  handleSave,
  handleClose,
}: {
  handleSave: (fileEntryFormData: FileEntryFormData) => Promise<void>;
  handleClose: () => void;
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <StyledInputContainer isMobile={isMobile}>
      <AddNewFileDialog
        fileEntry={undefined}
        handleSave={handleSave}
        handleClose={handleClose}
      />
    </StyledInputContainer>
  );
};
